// js-button-allowance.js
;(() => {
    const disabledClass = 'button--disabled'

    function updateButton(button, fields, type) {
        let allowButton = true
        fields.forEach(f => {
            if (type === 'one-char') {
                allowButton &= f?.value?.length > 0
            }
        })

        if (allowButton) {
            button.classList.remove(disabledClass)
        } else {
            button.classList.add(disabledClass)
        }
    }

    document.querySelectorAll('.js-button-allowance').forEach(button => {
        const form = button.closest('.js-button-allowance-form')
        const allowanceFiedsNames = button.dataset.allowanceFields.split('|')
        const type = button.dataset.allowanceType
        
        if (!form || !type || allowanceFiedsNames.length == 0) return

        const allowanceFieds = allowanceFiedsNames.map(name => {
            return form.querySelector(`[name="${name}"]`)
        })

        allowanceFieds.forEach(field => {
            field.addEventListener('input', updateThisButton)
        })

        form.addEventListener('reset', () => {
            setTimeout(() => updateThisButton(), 50)
        })

        function updateThisButton() {
            updateButton(button, allowanceFieds, type)
        }

        updateThisButton()
    })
})();